import type { PagedResultDto } from "@services/dto/pagedResultDto"
import { notifySuccess } from "@lib/helper"
import http from "../httpService"
import { LNotification } from "@lib/abpUtility"

class ViewService {
  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/View/GetAll", {
      params,
    })
    return res.data.result
  }
  public async getList(params?: any): Promise<any> {
    const res = await http.get("api/services/app/View/GetList", {
      params,
    })
    const { result } = res.data
    return result
  }
  public async get(id: number): Promise<any> {
    const res = await http.get("api/services/app/View/Get", {
      params: { id },
    })
    return res.data.result
  }

  public async createOrUpdate(body: any) {
    const res = await http.post("api/services/app/View/CreateOrUpdate", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }
  public async activate(id: number, isActive) {
    const res = await http.post(
      "api/services/app/View/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }
}

export default new ViewService()
